import { useState } from 'react'

import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

interface FilterCityProps {
  selectedCities: string[]
  onChangeCities: (cities: string[]) => void
}

export default function FilterCity({ selectedCities, onChangeCities }: FilterCityProps) {
  const [inputValue, setInputValue] = useState('')
  const [showWarning, setShowWarning] = useState(false)
  const maxInputLength = 40

  const handleBlur = () => {
    const trimmedValue = inputValue.trim()
    if (trimmedValue && !selectedCities.includes(trimmedValue)) {
      onChangeCities([...selectedCities, trimmedValue])
      setInputValue('')
    }
  }

  return (
    <Autocomplete
      value={selectedCities}
      multiple
      freeSolo
      options={[] as string[]}
      getOptionLabel={(option) => `${option}`}
      onChange={(_, selectedCities) => onChangeCities(selectedCities)}
      inputValue={inputValue}
      onBeforeInput={() => {
        if (inputValue.length === maxInputLength) {
          setShowWarning(true)
        }
      }}
      onInputChange={(_, value) => {
        setShowWarning(false)
        setInputValue(value)
      }}
      onBlur={handleBlur}
      ChipProps={{ color: 'primary', variant: 'outlined' }}
      renderInput={(params) => (
        <TextField
          {...params}
          color="primary"
          variant="outlined"
          label="City"
          helperText={
            showWarning
              ? `City names cannot be more than ${maxInputLength} characters long.`
              : 'Press Enter to add more cities'
          }
          error={showWarning}
          inputProps={{
            ...params.inputProps,
            maxLength: maxInputLength,
          }}
        />
      )}
    />
  )
}
